
<div class="room-container"  [@fadeInOnEnter] [@fadeOutOnLeave] [class.is-multi-room]="isMultiRoom">

    <app-image-gallery1 [roomCode]="roomData.roomrates[0].room.roomCode" [hotelCode]="avService.getSearchParams()?.hotelCode"></app-image-gallery1>
        <!-- <app-image-gallery2 [roomCode]="roomData.room.roomCode"></app-image-gallery2> -->


    @if (fewLeft) {
        <div class="few-left-info">
            <span class="material-symbols-outlined">
                notifications_active
            </span>
            @if (roomData.roomrates[0].room.numberOfRoomsAvailable == 1){
                {{"av.fewLeftNoticeSingle"|translate:{value: roomData.roomrates[0].room.numberOfRoomsAvailable} }}
            }
            @else {
                {{"av.fewLeftNotice"|translate:{value: roomData.roomrates[0].room.numberOfRoomsAvailable} }}
            }
        </div>
    }

    @if (avService.getCategoryName(roomData.roomrates[0].room)) {
        <div class="room-category-tag">{{avService.getCategoryName(roomData.roomrates[0].room)}}</div>
    }


    <div class="room-data">

        <h4 class="room-name" [attr.data-testid]="'room-title'">{{roomData.roomrates[0].room.pim?.name ?? roomData.roomrates[0].room.roomName}}</h4>

        <div class="amenities">
            @for (amenity of roomData.roomrates[0].room.pim?.amenities; track $index) {
                @if($index < 2) {
                    <div  class="amenity">
                        @if (amenity == 'tv') {
                            <span class="amenity-icon">
                                <span class="material-symbols-outlined">tv</span>
                            </span>
                            <span class="amenity-text">{{"av.Television"|translate}}</span>
                        }
                        @if (amenity == 'kingbed') {
                            <span class="amenity-icon">
                                <span class="material-symbols-outlined">king_bed</span>
                            </span>
                            <span class="amenity-text">{{"av.KingBed"|translate}}</span>
                        }
                        @if (amenity == 'twin') {
                            <span class="amenity-icon">
                                <span class="material-symbols-outlined">single_bed</span>
                                <span class="material-symbols-outlined">single_bed</span>
                            </span>
                            <span class="amenity-text">{{"av.TwoSingleBeds"|translate}}</span>
                        }
                        @if (amenity == 'ac') {
                            <span class="amenity-icon">
                                <span class="material-symbols-outlined">ac_unit</span>
                            </span>
                            <span class="amenity-text">{{"av.AC"|translate}}</span>
                        }
                    </div>
                }


            }
           <!--  @if (roomData.roomrates[0].room.pim.amenities.length > 2) {
                <div  class="amenity">
                    <span class="amenity-icon">
                        <span class="material-symbols-outlined">
                            more_horiz
                        </span>
                    </span>
                </div>
            } -->
        </div>
        <!-- <div class="selling-points">
            @for (sp of roomData.room.sellingPoints; track $index) {
                <div  class="selling-point">
                    <span class="sp-text" [innerHTML]="sp.replace('sqm', 'm<sup>2</sup>')"></span>
                </div>
            }
        </div> -->

        <div class="room-description">
            <app-truncated-text [text]="roomData.roomrates[0].room.pim?.shortDescription" [truncateHeight]="settings.get('availability.roomDescriptionMaxHeight')" [attr.data-testid]="'room-description'"></app-truncated-text>
        </div>
        <p-button [outlined]="true" size="small" (click)="readMore()" class="mb-2" [attr.data-testid]="'read-more-about-room'">{{ readMoreLabel ?? ('av.ReadMore'|translate) }}
            <span class="material-symbols-outlined">
                open_in_full
            </span>
        </p-button>
        @if (roomData.roomrates)
        {
            <div class="rates-container">
                @if (roomData.roomrates.length == 1) {
                    <app-availability-room-2-rate [rate]="roomData.roomrates[0]" (onSelect)="selectRoomRate(roomData.roomrates[0])" [class.rate-highlight]="roomData.roomrates[0].rate.bookingCode" [class.has-tag]="roomData.roomrates[0].rate.bookingCode || roomData.roomrates[0].rate.isNonRef || roomData.roomrates[0].rate.isLastMinute"></app-availability-room-2-rate>
                }
                @else {
                    <p-accordion [attr.data-testid]="'price-accordion'">
                        @for (rate of roomData.roomrates; track $index) {
                            @if ($index < settings.get("availability.maxVisibleRates")) {
                                <p-accordion-panel [value]="$index" [class.accordion-rate-highlight]="rate.rate.bookingCode" [class.has-tag]="rate.rate.isLastMinute || rate.rate.isNonRef" [attr.data-testid]="'room-' + roomIndex + '-accordion-panel-' + $index">
                                    <p-accordion-header [attr.data-testid]="'price-accordion-header'">
                                        <ng-template #toggleicon let-active="active">
                                            @if (active) {
                                                <span class="material-symbols-outlined">keyboard_arrow_up</span>
                                            } @else {
                                                <span class="material-symbols-outlined">keyboard_arrow_down</span>
                                            }
                                        </ng-template>
                                        <span class="rate-header-name me-auto">{{rate|formatRateName}}</span> 
                                        @if (settings.get("availability.showOriginalPriceIfDiscount") && rate.totalOriginalPrice > rate.totalPriceForStayWithTaxes) {
                                            <div class="rate-original-price" [innerHTML]="rate.totalOriginalPrice|displayPrice" [attr.data-testid]="'rate-original-price'"></div>
                                        }
                                         <span class="rate-header-price" [innerHTML]="rate.totalPriceForStayWithTaxes|displayPrice"></span>

                                        @if (rate.rate.bookingCode) {
                                            <div class="room-booking-code-tag">{{'av.roomHasBookingCode'|translate}} <span class="room-booking-code-name">{{rate.rate.bookingCode}}</span></div>
                                        }
                                        @if (rate.rate.isLastMinute) {
                                            <div class="room-annotation-tag">{{'av.lastMinuteRate'|translate}}</div>
                                        }
                                        @if (rate.rate.isNonRef) {
                                            <div class="room-annotation-tag">{{'av.nonRefundableRate'|translate}}</div>
                                        }

                                    </p-accordion-header>

                                    <p-accordion-content [attr.data-testid]="'price-accordion-content'">
                                        <app-availability-room-2-rate [isInAccordion]="true" [rate]="rate" (onSelect)="selectRoomRate(rate)"></app-availability-room-2-rate>
                                    </p-accordion-content>
                                </p-accordion-panel>
                            }
                        }
                    </p-accordion>

                    @if (roomData.roomrates.length > settings.get('availability.maxVisibleRates')) {
                        <div class="d-flex justify-content-end">
                            <p-button  [text]="true" (click)="openMoreRates();" [attr.data-testid]="'open-more-rates'">{{"av.showMoreRates"|translate}}</p-button>
                        </div>
                    }
                }
            </div>
        }
    </div>

</div>

